var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L44.5922 28.9134L68.2843 11.7157L51.0866 35.4078L80 40L51.0866 44.5922L68.2843 68.2843L44.5922 51.0866L40 80L35.4078 51.0866L11.7157 68.2843L28.9134 44.5922L0 40L28.9134 35.4078L11.7157 11.7157L35.4078 28.9134L40 0Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefine);
export default __webpack_public_path__ + "static/media/define.081bbecafac31624513c34c71d6351f4.svg";
export { ForwardRef as ReactComponent };